(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    class MaisonInlineAdd extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.product = JSON.parse(this.querySelector('script').textContent);
      this.selection = this.product.options.map((_, index) => {
        const values = [...new Set(this.product.variants.map(variant => variant.options[index]))];
        return values.length === 1 ? values[0] : null;
      });
      this.steps = this.product.options.map((name, index) => ({ name, index })).filter(step => this.selection[step.index] === null).sort((a, b) => Number(/size|größe|velikost/i.test(a.name)) - Number(/size|größe|velikost/i.test(b.name)));
      this.querySelector('summary').addEventListener('click', event => event.stopPropagation());
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-option]');
        if (!button || this.busy) return;
        event.preventDefault();
        event.stopPropagation();
        if (button.dataset.option !== 'direct') this.selection[Number(button.dataset.option)] = button.dataset.value;
        if (this.selection.every(value => value !== null)) this.add();
        else this.render();
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          this.querySelector('details').open = false;
          this.querySelector('summary').focus();
        }
      });
      this.render();
    }
    displayValue(value) {
      return this.product.values?.[value.toLowerCase().trim()] || value;
    }
    displayName(name) {
      if (/^(size|größe|velikost)$/i.test(name)) return this.product.labels?.size || name;
      if (/^(colou?r|farbe|barva)$/i.test(name)) return this.product.labels?.color || name;
      return name;
    }
    render() {
      const choices = this.querySelector('.ma-inline-add__choices');
      const restoreFocus = choices.contains(document.activeElement);
      choices.replaceChildren();
      const step = this.steps.find(item => this.selection[item.index] === null);
      if (!step) {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.option = 'direct';
        button.textContent = this.product.variants[0].options.map(value => this.displayValue(value)).join(' / ');
        button.disabled = !this.product.variants[0].available;
        choices.append(button);
        if (restoreFocus && !button.disabled) button.focus({ preventScroll: true });
        return;
      }
      choices.setAttribute('aria-label', this.displayName(step.name));
      const values = [...new Set(this.product.variants.map(variant => variant.options[step.index]))];
      for (const value of values) {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.option = String(step.index);
        button.dataset.value = value;
        button.textContent = this.displayValue(value);
        button.setAttribute('aria-label', `${this.displayName(step.name)}: ${this.displayValue(value)}`);
        button.disabled = !this.product.variants.some(variant => variant.available && variant.options[step.index] === value && this.selection.every((selected, index) => selected === null || variant.options[index] === selected));
        choices.append(button);
      }
      if (restoreFocus) choices.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
    }
    async add() {
      const variant = this.product.variants.find(item => item.available && item.options.every((value, index) => value === this.selection[index]));
      if (!variant || this.busy) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      const status = this.querySelector('.ma-inline-add__status');
      status.textContent = '';
      const root = window.Shopify?.routes?.root || '/';
      try {
        const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(element => element.dataset.sectionId))].slice(0, 5);
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: variant.min }], sections: sectionIds, sections_url: location.pathname }) });
        const added = await response.json();
        if (!response.ok) throw new Error(added.description || added.message || this.dataset.unavailable);
        status.textContent = `${this.dataset.added} — ${variant.options.map(value => this.displayValue(value)).join(' / ')}`;
        try {
          const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          const cart = cartResponse.ok ? await cartResponse.json() : null;
          if (cart) {
            const drawers = [...document.querySelectorAll('cart-drawer-component[auto-open]')];
            drawers.forEach(drawer => drawer.removeAttribute('auto-open'));
            try {
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: String(variant.id), data: { source: 'ma-inline-add', itemCount: cart.item_count, productId: this.dataset.productId, sections: added.sections } } }));
            } finally {
              drawers.forEach(drawer => drawer.setAttribute('auto-open', ''));
            }
          }
        } catch {}
      } catch (error) {
        status.textContent = error.message || this.dataset.unavailable;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.selection = this.selection.map((value, index) => this.steps.some(step => step.index === index) ? null : value);
        this.render();
      }
    }
  }
  if (!customElements.get('ma-inline-add')) customElements.define('ma-inline-add', MaisonInlineAdd);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-ma-ad-size-open]');
  if (!trigger) return;
  const headings = document.querySelectorAll('.ma-yvon-accordion');
  for (const item of headings) {
    if (!item.querySelector('table')) continue;
    const detail = item.closest('details');
    if (detail) detail.open = true;
    const control = item.querySelector('[aria-expanded]');
    if (control && control.getAttribute('aria-expanded') !== 'true') control.click();
    item.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    break;
  }
});
  } catch(e) { console.error(e); }
})();

})();
